import { render, staticRenderFns } from "./DnDShipper.vue?vue&type=template&id=c319c020&"
import script from "./DnDShipper.vue?vue&type=script&lang=ts&"
export * from "./DnDShipper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports